import React, { JSX } from 'react';
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Container, SxProps, Theme } from "@mui/material";
import CustomTypography from '../custom-typography/CustomTypography';
import { X } from '@phosphor-icons/react';


const spacing = 4;

const style: SxProps<Theme> = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {
        xs: "75%",
        md: 500
    },
    bgcolor: '#F0F0F0',
    borderRadius: "8px",
    boxShadow: 24,
    p: spacing
};

interface CustomModalI {
    isOpen: boolean,
    handleClose: () => void
    title?: string,
    showX?: boolean,
    children?: JSX.Element,
    sx?: SxProps<Theme>
}

const CustomModal = ({ isOpen, handleClose, showX = true, title, children, sx }: CustomModalI) => {


    return (
        <Container fixed>
            <Modal
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
                open={isOpen}
                onClose={(event, reason) => {
                    
                    if (reason !== "backdropClick") {
                        handleClose();
                    }
                }}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            ><Fade in={isOpen}>
                    <Box sx={{ ...style, position: "relative", ...sx }}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: !title ? "absolute" : "initial",
                            right: 30,
                            mb: title && spacing
                        }}>
                            <CustomTypography variant={"h5"}>
                                {title}
                            </CustomTypography>
                            {showX && <Button onClick={handleClose} variant={"text"}
                                sx={{
                                    color: "black",
                                    borderRadius: "99px",
                                    width: "2rem !important",
                                    height: "2rem !important",
                                    p: 0
                                }}>
                                <X size={25} />
                            </Button>}
                        </Box>
                        {children}
                    </Box>
                </Fade>
            </Modal>
        </Container>
    );
};

export default CustomModal;
